import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Using Your Python Skills`}</h1>
    <p>{`You've built out a great toolkit of computer science fundamentals over the course of these topics!
You've also built some of your own projects to practice and show off your new skills! So what's
next?`}</p>
    <Video alt="Using Your Python Skills" videoId="3cs-i0Y3gDw" mdxType="Video" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      